import { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';

import { useAppClearCacheRegister } from '@/hooks/useAppClearCache';
import { usePrivacyVersionCheck } from '@/pages/Privacy/config';
import { MCDProvider } from './context';
import routes from './routes/index.douyin';

import './styles/index.less';
import { initTracker } from '@/utils/tracker';
import VConsole from 'vconsole';
import { channelInitSafeAreaCssVar } from './channels';
import WelcomePendingPage from '@/pages/Welcome/Pending';
import { useAmpHandler } from '@/utils/elk';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const App = () => {
  console.log(`Version: ${process.env.COMMIT_HASH || 'unknown'}`);
  const routeElements = useRoutes(routes);
  useAppClearCacheRegister();
  const { loading } = usePrivacyVersionCheck();

  useAmpHandler();
  initTracker();

  if (process.env.APP_DEPLOY_ENV !== 'prod') {
    new VConsole();
  }

  useEffect(() => {
    channelInitSafeAreaCssVar();
  }, []);

  if (loading === false) {
    return <Suspense fallback={<WelcomePendingPage />}>{routeElements}</Suspense>;
  }
  return <WelcomePendingPage />;
};

root.render(
  <Provider store={store}>
    <MCDProvider>
      <Router>
        <App />
      </Router>
    </MCDProvider>
  </Provider>,
);
